import { Injectable } from '@angular/core';
import { LinegraphApiService } from './linegraph.api.service';

import { LineGraph } from '../../models/linegraphData';
import { Observable } from 'rxjs/Observable';
import { PerspectiveGraphValue } from '../../models/perspectiveGraphValue';

@Injectable()
export class LinegraphDomainService {
    constructor(private linegraphApiService: LinegraphApiService) { }

    getLineGraphData(date: Date, jobId: string): Observable<{} | LineGraph> {
        return this.linegraphApiService.getLineGraph(date, jobId);
    }

    getMultiDaylineGraph(jobId: string, dates: Date[]): Observable<{} | LineGraph[]> {
        return this.linegraphApiService.getMultiDaylineGraph(jobId, dates);
    }

    getPerspectiveData(jobId: string, dayOfWeek: number): Observable<{} | PerspectiveGraphValue> {
        return this.linegraphApiService.getPerspective(jobId, dayOfWeek);
    }

    getLineGraphCsv(jobId: string, dates: Date[], filename: string): void {
        return this.linegraphApiService.getLineGraphCsv(jobId, dates, filename);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/linegraph/linegraph.domain.service.ts